import { computed } from 'vue'

import { Language } from '@/enums/language.ts'
import i18n from '@/libs/i18n'
import type { DropdownType } from '@/types/Common.ts'

const { t } = i18n.global

export const AvailableLanguages = computed((): DropdownType[] => {
    return [
        { name: `🇸🇮 ${t('language.slovenian')}`, value: Language.Slovenian, image: '🇸🇮' },
        { name: `🇬🇧 ${t('language.english')}`, value: Language.English, image: '🇬🇧' }
    ]
})

export const getLanguage = (value: string | Language): DropdownType => {
    const index = AvailableLanguages.value.findIndex(x => x.value === value)
    return index > -1 && AvailableLanguages.value[index] ? AvailableLanguages.value[index] : { name: '', value: '', image: '' }
}

